import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PopupMessage from '../components/PopupMessage';
import CustomerForm from '../components/CustomerForm';
import { Link } from "react-router-dom";
import Preferences from '../components/Preferences';
import LivePreview from '../components/LivePreview';


function EditCustomerPage({ onLogout }) {
    const { customerId } = useParams();
    const navigate = useNavigate();

   const styles = {
    mainContainer: { 
        maxWidth: '938px', // Was 1400px
        width: '100vw',
        margin: '1.34rem auto', // Was 2rem
        boxShadow: '0 3px 8px rgba(0,0,0,0.1)', // Was 0 4px 12px
        borderRadius: '5px', // Was 8px
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 2.68rem)', // Was calc(100vh - 4rem)
    },
    container: { 
        display: 'flex', 
        width: '100%', 
        direction: 'rtl', 
        flex: 1,
        overflow: 'hidden'
    },
    column: { 
        padding: '1rem', // Was 1.5rem
        boxSizing: 'border-box',
        backgroundImage: 'linear-gradient(270deg, #353535, #687b92)',
        color: 'white',
        overflowY: 'auto'
    },
    rightColumn: { 
        flex: '0 0 25%', 
        borderLeft: '1px solid #ddd', // Borders are kept at 1px for sharpness
        borderRadius:'0 20px 0 0', // Was 30px
    },
    middleColumn: { 
        flex: '0 0 50%', 
        borderLeft: '1px solid #ddd', // Borders are kept at 1px for sharpness
    },
    leftColumn: { 
        flex: '0 0 25%',
        borderRadius:'20px 0 0 0', // Was 30px
    },
    saveButtonContainer: { 
        padding: '0.67rem 1rem', // Was 1rem 1.5rem
        borderTop: '1px solid #ddd', // Borders are kept at 1px for sharpness
        backgroundColor: '#000000ff',
        display: 'flex',
        gap: '0.67rem', // Was 1rem
    },
    finalSaveButton: { 
        backgroundColor: '#28a745', 
        color: 'white', 
        border: 'none', 
        padding: '0.67rem', // Was 1rem
        borderRadius: '5px', // Was 8px
        cursor: 'pointer', 
        fontSize: '0.8rem', // Was 1.2rem
        width: '100%',
        textAlign: 'center',
    },
    cancelButton: {
        backgroundColor: '#6c757d',
        color: 'white',
        border: 'none',
        padding: '0.5rem 0.67rem', // Was 0.75rem 1rem
        borderRadius: '5px', // Was 8px
        cursor: 'pointer',
        fontSize: '0.74rem', // Was 1.1rem
        width: '100%',
        textAlign: 'center',
        textDecoration: 'none',
        display: 'block',
    },
    loadingText: { 
        textAlign: 'center', 
        fontSize: '1rem', // Was 1.5rem
        color: '#555', 
        padding: '3.35rem' // Was 5rem
    }
};
    const [customerData, setCustomerData] = useState(null);
    const [preferencesData, setPreferencesData] = useState({ groups: [] });
    const [popup, setPopup] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(false);
    const [isPhoneFocused, setIsPhoneFocused] = useState(false);
    
    // State to manage the selected group between Preferences and LivePreview
    const [selectedGroup, setSelectedGroup] = useState('');

    const PHONE_REGEX = /^09\d{9}$/;

    useEffect(() => {
        if (customerData) {
            setIsPhoneValid(PHONE_REGEX.test(customerData.phoneNumber));
        }
    }, [customerData?.phoneNumber]);

    useEffect(() => {
        const fetchCustomerDetails = async () => {
            if (!customerId) return;
            setIsLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                onLogout();
                return;
            }
            try {
                const response = await fetch(`https://interactivebot.tgnsys.ir/api/get_customer_details.php?id=${customerId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (response.status === 401) {
                    onLogout();
                    return;
                }
                const result = await response.json();
                if (result.status === 'success') {
                    setCustomerData(result.data.customer);
                    setPreferencesData(result.data.preferences);
                } else {
                    setPopup({ message: result.message, type: 'error' });
                }
            } catch (error) {
                setPopup({ message: `خطای دریافت اطلاعات مشتری: ${error.message}`, type: 'error' });
            } finally {
                setIsLoading(false);
            }
        };
        fetchCustomerDetails();
    }, [customerId, onLogout]);

    const handleUpdate = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            onLogout();
            return;
        }
        // ... validation logic ...
        
        const preferencesToSend = [];
        preferencesData.groups.forEach(group => {
            group.items.forEach(item => {
                if (item.is_visible || item.is_selectable) {
                    preferencesToSend.push({ ...item, group_number: group.group_number, group_title: group.group_title });
                }
            });
        });

        const payload = {
            customer: { ...customerData, id: customerId },
            preferences: preferencesToSend
        };

        try {
            const response = await fetch('https://interactivebot.tgnsys.ir/api/update_customer.php', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });
            
            if (response.status === 401) {
                onLogout();
                return;
            }

            const result = await response.json();
            if (response.ok) {
                setPopup({ message: result.message, type: 'success' });
                setTimeout(() => navigate('/'), 2000);
            } else {
                setPopup({ message: result.message || 'An unknown server error occurred.', type: 'error' });
            }
        } catch (error) {
            setPopup({ message: `Connection error: ${error.message}`, type: 'error' });
        }
    };

    if (isLoading || !customerData) {
        return <div style={styles.loadingText}>در حال بارگذاری اطلاعات مشتری...</div>;
    }

    return (
        <div style={styles.mainContainer}>
            <PopupMessage message={popup.message} type={popup.type} onClose={() => setPopup({ message: '', type: '' })} />
            <div style={styles.container}>
                <div style={{ ...styles.column, ...styles.rightColumn }}>
                    <CustomerForm 
                        customerData={customerData} onCustomerChange={setCustomerData}
                        isPhoneValid={isPhoneValid} isPhoneFocused={isPhoneFocused}
                        onPhoneFocus={() => setIsPhoneFocused(true)} onPhoneBlur={() => setIsPhoneFocused(false)}
                    />
                </div>
                <div style={{ ...styles.column, ...styles.middleColumn }}>
                    <Preferences 
                        preferences={preferencesData} 
                        onPreferencesChange={setPreferencesData}
                        selectedGroup={selectedGroup}
                        onGroupChange={setSelectedGroup} 
                    />
                </div>
                <div style={{ ...styles.column, ...styles.leftColumn }}>
                    <LivePreview 
                        preferences={preferencesData} 
                        onPreferencesChange={setPreferencesData}
                        onGroupSelect={setSelectedGroup}
                    />
                </div>
            </div>
            <div style={styles.saveButtonContainer}>
            <Link to="/" style={styles.cancelButton}>
                انصراف
            </Link>
            <button style={styles.finalSaveButton} onClick={handleUpdate}>
                به‌روزرسانی اطلاعات مشتری
            </button>
        </div>
        </div>
    );
}

export default EditCustomerPage;